// Fleet.jsx
import { motion } from 'framer-motion';
import { FLEET } from '../../data/siteData';
import './Fleet.css';

export default function Fleet() {
  return (
    <section className="section fleet" id="fleet">
      <div className="container">
        <div className="fleet__head">
          <p className="eyebrow">Our Fleet</p>
          <h2 className="section-title">Heavy Machines,<br />Ready To Roll.</h2>
        </div>

        <div className="fleet__grid">
          {FLEET.map((f, i) => (
            <motion.div
              className={`fleet-card ${i % 3 === 1 ? 'fleet-card--tall' : ''}`}
              key={f.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <img src={f.img} alt={f.title} loading="lazy" />
              <div className="fleet-card__overlay">
                <div className="fleet-card__content">
                  <h4>{f.title}</h4>
                  <p>{f.spec}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}